window.Vue = require('vue');
Vue.prototype._t = window._t;
window.Event = new Vue();
import Error from './classes/Error';
window.Error = Error;

window._ = require('lodash');
window.Popper = require('popper.js').default;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    require('jquery-ui-dist/jquery-ui');

    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(null, function(err) {
    if (!err.response) {
        return Promise.reject(err);
    }

    // fix: BRAIN-5F — sessione scaduta: non reindirizzare a / (protetta) ma al login
    if (err.response.status === 401 || err.response.status === 419 || err.response.statusText === 'Unauthorized') {
        var loginUrl = '/login?session_expired=1';
        if (window.location.pathname !== '/login') {
            document.location.href = loginUrl;
        }

        return Promise.reject(err);
    }

    if (err.response.status === 403) {
        if (err.response.hasOwnProperty('data')
            && err.response.data.hasOwnProperty('redirect_to')
        ) {
            document.location.href = err.response.data.redirect_to;
        }
    }

    return Promise.reject(err);
});

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = window.token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// Laravel Echo configuration - wrapped in try-catch for graceful fallback
try {
    // Import con supporto CommonJS e ES modules per compatibilità webpack
    const EchoModule = require('laravel-echo');
    const PusherModule = require('pusher-js');
    
    // Estrai la classe corretta (supporta sia .default che direct export)
    const Echo = EchoModule.default || EchoModule;
    const Pusher = PusherModule.default || PusherModule;
    
    window.Pusher = Pusher;

    // AUTO-DETECTION ambiente (UN SOLO BUNDLE PER TUTTI GLI AMBIENTI!)
    const hostname = window.location.hostname;
    const isLocalDev = hostname === 'localhost' || hostname.endsWith('.test') || hostname.endsWith('.crm.com') || hostname === '127.0.0.1';
    
    const reverbConfig = {
        key: process.env.MIX_REVERB_APP_KEY || 'yk32kgp5t51ysg8rb5aa',
        host: isLocalDev ? 'localhost' : hostname,
        port: isLocalDev ? 8080 : 443,
        scheme: isLocalDev ? 'https' : 'https'
    };

    if (reverbConfig.key) {
        const isProduction = !isLocalDev;
        
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: reverbConfig.key,
            cluster: 'mt1',
            wsHost: reverbConfig.host,
            wsPort: reverbConfig.port,
            wssPort: reverbConfig.port,
            forceTLS: isProduction,
            encrypted: isProduction,
            enabledTransports: ['ws', 'wss'],
            disableStats: true,
            authEndpoint: '/broadcasting/auth',
            auth: {
                headers: {
                    'X-CSRF-TOKEN': window.axios.defaults.headers.common['X-CSRF-TOKEN']
                }
            }
        });
    } else {
        window.Echo = null;
    }
} catch (error) {
    console.error('❌ Laravel Echo initialization failed:', error);
    window.Echo = null;
}

// Carica dipendenze di base
require('jquery-slimscroll');

window.Swal = require('sweetalert2');

window.moment = require('moment');

// Carica Summernote e aspetta prima di caricare le localizzazioni
require('summernote');

// Assicurati che Summernote sia disponibile prima di caricare le localizzazioni
if (typeof window.$ !== 'undefined' && window.$.fn.summernote) {
    try {
        require('summernote/dist/lang/summernote-bg-BG');
        require('summernote/dist/lang/summernote-it-IT');
    } catch (e) {
        console.warn('Summernote language files could not be loaded:', e);
    }
}

window.WOW = require('wowjs');

require('bootstrap-daterangepicker');

require('mark.js/dist/jquery.mark');
window.JSZip = require('jszip');

// Carica DataTables core PRIMA dei plugin
require('datatables.net');
require('datatables.net-bs');

// Carica i plugin DataTables DOPO il core
require('datatables.net-buttons');
require('datatables.net-buttons-bs');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');

// Plugin aggiuntivi
require('datatables.mark.js/dist/datatables.mark');
require('./vendor/dataTables/dataTables.cellEdit');

require('jquery-file-download');

require('blueimp-tmpl');
require('blueimp-gallery/js/jquery.blueimp-gallery');
require('blueimp-file-upload/js/jquery.fileupload-ui');
require('blueimp-file-upload');

require('admin-lte');

// Carica Select2 e assicurati che sia disponibile globalmente
require('select2/dist/js/select2.full.js');
require('select2/dist/js/i18n/it');

require('./vendor/iosCheckbox/iosCheckbox');

// Carica Cropper e assicurati che sia disponibile globalmente
require('cropper');

require('fullcalendar/dist/fullcalendar');
require('fullcalendar/dist/locale/it');

require('bootstrap-colorselector/dist/bootstrap-colorselector');

require('icheck');

require('slick-carousel');

require('gridstack/dist/gridstack.js');
require('gridstack/dist/gridstack.jQueryUI.js');
